import { useSearchParams } from "react-router-dom";

export const useURLSearchParamSingleValue = (key: string): string | null => {
  const [searchParams] = useSearchParams();
  return searchParams.get(key) ?? null;
};

export const useURLSearchParamsList = (key: string): string[] | null => {
  const searchParam = useURLSearchParamSingleValue(key);
  return searchParam?.split(",") ?? null;
};

export const useURLSearchParam = (key: string): string | null => {
  const searchParams = useURLSearchParamsList(key);
  return searchParams?.[0] ?? null;
};

// required as long as VariantTrackLoader is a class component
export const getURLSearchParamsList = (key: string): string[] | null => {
  const searchParams = new URLSearchParams(window.location.search);
  const searchParam = searchParams.get(key) ?? null;
  return searchParam?.split(",") ?? null;
};
